import IconLoader from '../icons/loader';
import { TransactionStatusLog } from './types';
import TransactionStatusLogs from '../transaction-status-logs/transaction-status-logs';

import styles from './transaction.module.css';

interface TransactionLogsContentProps {
  logs?: TransactionStatusLog[];
  isLoading: boolean;
  activePermission?: boolean;
}

export default function TransactionLogsContent({
  logs,
  isLoading,
  activePermission,
}: TransactionLogsContentProps): React.JSX.Element {
  let content;

  if (isLoading) {
    content = (
      <div className={styles.loader}>
        <IconLoader className={styles.loaderIcon} />
      </div>
    );
  } else if (!activePermission) {
    content = (
      <div className={styles.emptyStatusLogs}>
        You don&apos;t have access to this section
      </div>
    );
  } else {
    content = <TransactionStatusLogs logs={logs} />;
  }

  return content;
}
